import React, { useState, useEffect } from "react";
import {
  Box,
  createTheme,
  Stack,
  Typography,
  Grid,
  Skeleton,
  TextField,
  Autocomplete,
  Radio,
} from "@mui/material";
import axios from "axios";
import { useStateValue } from "../../../StateProvider";
import PropTypes from "prop-types";
import { useAutocomplete } from "@mui/base/AutocompleteUnstyled";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { useParams } from "react-router-dom";
import NetIncomeChart from "./Charts/NetIncomeChart";
import OPEXCharts from "./Charts/OPEXCharts";
import OutstandingSharesChart from "./Charts/OutstandingSharesChart";
import MarketCapChart from "./Charts/MarketCapChart";
import EarningsPerShareChart from "./Charts/EarningsPerShareChart";

const StockComparison = ({ mode }) => {
  const [{ token }] = useStateValue();
  const [stocks, setStocks] = useState([]);
  const [attribute, setAttribute] = useState("EPS");
  const [stocksToCompare, setStocksToCompare] = useState([]);
  const [incomeDetails, setIncomeDetails] = useState([]);
  const [finalIncomeDetails, setFinalIncomeDetails] = useState([]);
  const [finalIncomeDetailsForOPEX, setFinalIncomeDetailsForOPEX] = useState(
    []
  );
  const [reportedFinancials, setReportedFinancials] = useState([]);
  const [reportedFinancialsForOS, setReportedFinancialsForOS] = useState([]);
  const [reportedFinancialsForMC, setReportedFinancialsForMC] = useState([]);
  const [reportedFinancialsForEPS, setReportedFinancialsForEPS] = useState([]);

  const [financialPeriod, setFinancialPeriod] = useState("quarterly");
  const [error, setError] = useState("");
  useEffect(() => {
    setTimeout(() => {
      setError("");
    }, 5000);
  }, [error]);

  useEffect(() => {
    console.log("running");
    axios
      .get(`https://cloud.iexapis.com/stable/ref-data/symbols?token=${token}`)
      .then((res) => {
        // setStocks(res.data);
        let data = res.data?.filter((s) => s?.type == "cs");
        data = data?.map((d) => {
          return {
            symbol: d?.symbol,
          };
        });
        setStocks(data);
      })
      .catch((err) => console.log(err));
  }, []);
  useEffect(() => {
    // console.log("attribute, stocksToCompare", attribute, stocksToCompare);
    if (attribute == "Net Income" || attribute == "Operating Expenses") {
      let temp = [];

      let array = incomeDetails;
      setIncomeDetails([]);
      //   console.log("symbols", stocksToCompare, incomeDetails);
      stocksToCompare.map((s, index) => {
        let found = false;

        array?.map((inc) => {
          if (inc?.symbol == s?.symbol) {
            // temp?.push(inc);
            // console.log("running 4");
            setIncomeDetails([...incomeDetails, inc]);
            found = true;
          }
        });
        // console.log("foud", found, s?.symbol, incomeDetails);
        if (!found) {
          axios
            .get(
              ` https://cloud.iexapis.com/stable/stock/${s?.symbol}/income?period=annual&&last=16&&token=${token}`
            )
            .then((annualRes) => {
              axios
                .get(
                  ` https://cloud.iexapis.com/stable/stock/${s?.symbol}/income?period=quarterly&&last=16&&token=${token}`
                )
                .then((quarterlyRes) => {
                  if (annualRes?.data?.income?.length > 0) {
                    setIncomeDetails([
                      ...incomeDetails,
                      {
                        symbol: stocksToCompare[index]?.symbol,
                        details: {
                          annual: annualRes.data,
                          quarterly: quarterlyRes.data,
                        },
                      },
                    ]);

                    // }
                  } else {
                    setError("financials not available for " + s?.symbol);
                  }
                });
            });
        }
      });
    }
    if (
      attribute == "Outstanding Shares" ||
      attribute == "Market Cap" ||
      attribute == "EPS"
    ) {
      let temp = [];

      let array = reportedFinancials;
      setReportedFinancials([]);
      //   console.log("symbols", stocksToCompare, incomeDetails);
      stocksToCompare.map((s, index) => {
        let found = false;

        array?.map((fin) => {
          if (fin?.symbol == s?.symbol) {
            // temp?.push(fin);
            // console.log("running 4");
            setReportedFinancials([...reportedFinancials, fin]);
            found = true;
          }
        });
        // console.log("foud", found, s?.symbol, incomeDetails);
        console.log("symbol", s?.symbol, "token", token);
        if (!found) {
          axios
            .get(
              ` https://cloud.iexapis.com/stable/time-series/REPORTED_FINANCIALS/${s?.symbol}/10-K?token=${token}&&last=16`
            )
            .then((annualRes) => {
              axios
                .get(
                  ` https://cloud.iexapis.com/stable/time-series/REPORTED_FINANCIALS/${s?.symbol}/10-Q?token=${token}&&last=16`
                )
                .then((quarterlyRes) => {
                  console.log("annual res", annualRes);
                  if (
                    annualRes?.data?.length > 5 &&
                    quarterlyRes?.data?.length > 5
                  ) {
                    setReportedFinancials([
                      ...reportedFinancials,
                      {
                        symbol: stocksToCompare[index]?.symbol,
                        details: {
                          annual: annualRes.data,
                          quarterly: quarterlyRes.data,
                        },
                      },
                    ]);
                  } else {
                    setError("financials not available for " + s?.symbol);
                  }
                });
            });
        }
      });
    }
  }, [attribute, stocksToCompare]);
  useEffect(() => {
    // console.log("incomeDetails at second useeffect", incomeDetails);
    let incomeDetails2 = incomeDetails?.filter(
      (v, i, a) => a.findIndex((v2) => v2.symbol === v.symbol) === i
    );
    incomeDetails2 = incomeDetails2?.filter((inc) => {
      if (stocksToCompare?.find((s) => s?.symbol == inc?.symbol)) {
        return true;
      }
      return false;
    });
    // console.log("new income details", incomeDetails2);
    if (attribute == "Net Income") {
      if (financialPeriod == "annual") {
        let length = incomeDetails2[0]?.details?.annual?.income?.length;
        let smallestIncIndex = 0;
        incomeDetails2?.map((i, index) => {
          if (i?.details?.annual?.income?.length < length) {
            length = i?.details?.annual?.income?.length;
            smallestIncIndex = index;
          }
        });
        //   console.log("length", length);
        let annualDetails = [];

        for (let i = length; i >= 0; i--) {
          if (
            incomeDetails2[smallestIncIndex]?.details?.annual?.income[i]
              ?.fiscalYear
          ) {
            annualDetails?.push({
              financialPeriod:
                incomeDetails2[smallestIncIndex]?.details?.annual?.income[i]
                  ?.fiscalYear,
              incomes: incomeDetails2?.map((inc) => {
                return {
                  symbol: inc?.details?.annual?.symbol,
                  netIncome:
                    inc?.details?.annual?.income &&
                    inc?.details?.annual?.income[i]?.netIncome,
                };
              }),
            });
          }
        }

        console.log("final details", annualDetails);
        setFinalIncomeDetails(annualDetails);
      }
      if (financialPeriod == "quarterly") {
        let length = incomeDetails2[0]?.details?.quarterly?.income?.length;
        let smallestIncIndex = 0;
        incomeDetails2?.map((i, index) => {
          if (i?.details?.quarterly?.income?.length < length) {
            length = i?.details?.quarterly?.income?.length;
            smallestIncIndex = index;
          }
        });
        //   console.log("length", length);
        let quarterlyDetails = [];

        for (let i = 15; i >= 0; i--) {
          if (
            incomeDetails2[smallestIncIndex]?.details?.quarterly?.income[i]
              ?.fiscalYear
          ) {
            quarterlyDetails?.push({
              financialPeriod: `FY${
                incomeDetails2[smallestIncIndex]?.details?.quarterly?.income[i]
                  ?.fiscalYear - 2000
              } Q${
                incomeDetails2[smallestIncIndex]?.details?.quarterly?.income[i]
                  ?.fiscalQuarter
              }`,
              incomes: incomeDetails2?.map((inc) => {
                return {
                  symbol: inc?.details?.quarterly?.symbol,
                  netIncome: inc?.details?.quarterly?.income[i]?.netIncome,
                };
              }),
            });
          }
        }
        setFinalIncomeDetails(quarterlyDetails);
        console.log("quarterly details", quarterlyDetails);
      }
    }
    if (attribute == "Operating Expenses") {
      if (financialPeriod == "annual") {
        let length = incomeDetails2[0]?.details?.annual?.income?.length;
        let smallestIncIndex = 0;
        incomeDetails2?.map((i, index) => {
          if (i?.details?.annual?.income?.length < length) {
            length = i?.details?.annual?.income?.length;
            smallestIncIndex = index;
          }
        });
        //   console.log("length", length);
        let annualDetails = [];

        for (let i = length; i >= 0; i--) {
          if (
            incomeDetails2[smallestIncIndex]?.details?.annual?.income[i]
              ?.fiscalYear
          ) {
            annualDetails?.push({
              financialPeriod:
                incomeDetails2[smallestIncIndex]?.details?.annual?.income[i]
                  ?.fiscalYear,
              operatingExpenses: incomeDetails2?.map((inc) => {
                return {
                  symbol: inc?.details?.annual?.symbol,
                  operatingExpense:
                    inc?.details?.annual?.income &&
                    inc?.details?.annual?.income[i]?.operatingExpense,
                };
              }),
            });
          }
        }

        // console.log("final details", annualDetails);
        setFinalIncomeDetailsForOPEX(annualDetails);
      }
      if (financialPeriod == "quarterly") {
        let length = incomeDetails2[0]?.details?.quarterly?.income?.length;
        let smallestIncIndex = 0;
        incomeDetails2?.map((i, index) => {
          if (i?.details?.quarterly?.income?.length < length) {
            length = i?.details?.quarterly?.income?.length;
            smallestIncIndex = index;
          }
        });
        //   console.log("length", length);
        let quarterlyDetails = [];

        for (let i = 15; i >= 0; i--) {
          if (
            incomeDetails2[smallestIncIndex]?.details?.quarterly?.income[i]
              ?.fiscalYear
          ) {
            quarterlyDetails?.push({
              financialPeriod: `FY${
                incomeDetails2[smallestIncIndex]?.details?.quarterly?.income[i]
                  ?.fiscalYear - 2000
              } Q${
                incomeDetails2[smallestIncIndex]?.details?.quarterly?.income[i]
                  ?.fiscalQuarter
              }`,
              operatingExpenses: incomeDetails2?.map((inc) => {
                return {
                  symbol: inc?.details?.quarterly?.symbol,
                  operatingExpense:
                    inc?.details?.quarterly?.income[i]?.operatingExpense,
                };
              }),
            });
          }
        }
        setFinalIncomeDetailsForOPEX(quarterlyDetails);
        // console.log("quarterly details", quarterlyDetails);
      }
    }
  }, [incomeDetails, financialPeriod]);
  useEffect(() => {
    console.log("reported financials ", reportedFinancials);
    console.log("symbols", stocksToCompare);
    //for removing dupicate velues
    setReportedFinancialsForMC([]);
    let reportedFinancials2 = stocksToCompare.map((s) => {
      return reportedFinancials.filter((r) => r?.symbol == s?.symbol)[0];
    });

    // reportedFinancials?.filter(
    //   (v, i, a) => a.findIndex((v2) => v2.symbol === v.symbol) === i
    // );
    //for showing only those which are in stock to compare
    reportedFinancials2 = reportedFinancials2?.filter((inc) => {
      if (stocksToCompare?.find((s) => s?.symbol == inc?.symbol)) {
        return true;
      }
      return false;
    });
    console.log("reported financials 2", reportedFinancials2);
    if (attribute == "Outstanding Shares") {
      if (financialPeriod == "quarterly") {
        let length = reportedFinancials2[0]?.details?.quarterly?.length;
        let smallestIncIndex = 0;
        reportedFinancials2?.map((i, index) => {
          if (i?.details?.quarterly?.length < length) {
            console.log(i?.details?.quarterly?.length);
            length = i?.details?.quarterly?.length;
            smallestIncIndex = index;
          }
        });
        // console.log("length", length, smallestIncIndex);
        let quarterlyDetails = [];
        let financials = reportedFinancials2?.details?.quarterly;
        for (let i = 15; i >= 0; i--) {
          if (
            reportedFinancials2[smallestIncIndex]?.details?.quarterly[i]?.subkey
          ) {
            // console.log("running 2", reportedFinancials2);

            quarterlyDetails?.push({
              financialPeriod: reportedFinancials2[0]?.details?.quarterly[i]
                ?.DocumentFiscalPeriodFocus
                ? `FY${
                    reportedFinancials2[0]?.details?.quarterly[i]
                      ?.DocumentFiscalYearFocus - 2000
                  } ${
                    reportedFinancials2[0]?.details?.quarterly[i]
                      ?.DocumentFiscalPeriodFocus
                  }`
                : reportedFinancials2[0]?.details?.quarterly[i]
                    ?.formFiscalQuarter
                ? `FY${
                    reportedFinancials2[0]?.details?.quarterly[i]
                      ?.formFiscalYear - 2000
                  } Q${
                    reportedFinancials2[0]?.details?.quarterly[i]
                      ?.formFiscalQuarter
                  }`
                : `FY Q`,
              outstandingShares: reportedFinancials2?.map((fin) => {
                return {
                  symbol: fin?.symbol,
                  outstandingShares: fin?.details?.quarterly[i]
                    ?.CommonStockSharesOutstanding
                    ? fin?.details?.quarterly[i]?.CommonStockSharesOutstanding
                    : fin?.details?.quarterly[i]
                        ?.EntityCommonStockSharesOutstanding,
                };
              }),
            });
            // console.log("quarterly details", quarterlyDetails);
          }
        }
        console.log("runung 4");
        setReportedFinancialsForOS(quarterlyDetails);
        console.log("quarterly details", quarterlyDetails);
      }
      if (financialPeriod == "annual") {
        let length = reportedFinancials2[0]?.details?.annual?.length;
        let smallestIncIndex = 0;
        reportedFinancials2?.map((i, index) => {
          if (i?.details?.annual?.length < length) {
            console.log(i?.details?.annual?.length);
            length = i?.details?.annual?.length;
            smallestIncIndex = index;
          }
        });
        // console.log("length", length, smallestIncIndex);
        let annualDetails = [];
        let financials = reportedFinancials2?.details?.annual;
        for (let i = 15; i >= 0; i--) {
          if (
            reportedFinancials2[smallestIncIndex]?.details?.annual[i]?.subkey
          ) {
            console.log("running 2", reportedFinancials2);

            annualDetails?.push({
              financialPeriod: reportedFinancials2[0]?.details?.annual[i]
                ?.DocumentFiscalYearFocus
                ? reportedFinancials2[0]?.details?.annual[i]
                    ?.DocumentFiscalYearFocus
                : reportedFinancials2[0]?.details?.annual[i]?.formFiscalYear,
              outstandingShares: reportedFinancials2?.map((fin) => {
                return {
                  symbol: fin?.symbol,
                  outstandingShares: fin?.details?.annual[i]
                    ?.CommonStockSharesOutstanding
                    ? fin?.details?.annual[i]?.CommonStockSharesOutstanding
                    : fin?.details?.annual[i]
                        ?.EntityCommonStockSharesOutstanding,
                };
              }),
            });
          }
        }

        setReportedFinancialsForOS(annualDetails);
        console.log("annual details", annualDetails);
      }
    }
    /*********eps */
    if (attribute == "EPS") {
      console.log("reported Financial eps", reportedFinancials2);
      if (financialPeriod == "quarterly") {
        let length = reportedFinancials2[0]?.details?.quarterly?.length;
        let smallestIncIndex = 0;
        reportedFinancials2?.map((i, index) => {
          if (i?.details?.quarterly?.length < length) {
            console.log(i?.details?.quarterly?.length);
            length = i?.details?.quarterly?.length;
            smallestIncIndex = index;
          }
        });
        // console.log("length", length, smallestIncIndex);
        let quarterlyDetails = [];
        let financials = reportedFinancials2?.details?.quarterly;
        for (let i = 15; i >= 0; i--) {
          if (
            reportedFinancials2[smallestIncIndex]?.details?.quarterly[i]?.subkey
          ) {
            // console.log("running 2", reportedFinancials2);

            quarterlyDetails?.push({
              financialPeriod: reportedFinancials2[0]?.details?.quarterly[i]
                ?.DocumentFiscalPeriodFocus
                ? `FY${
                    reportedFinancials2[0]?.details?.quarterly[i]
                      ?.DocumentFiscalYearFocus - 2000
                  } ${
                    reportedFinancials2[0]?.details?.quarterly[i]
                      ?.DocumentFiscalPeriodFocus
                  }`
                : reportedFinancials2[0]?.details?.quarterly[i]
                    ?.formFiscalQuarter
                ? `FY${
                    reportedFinancials2[0]?.details?.quarterly[i]
                      ?.formFiscalYear - 2000
                  } Q${
                    reportedFinancials2[0]?.details?.quarterly[i]
                      ?.formFiscalQuarter
                  }`
                : `FY Q`,
              earningsPerShare: reportedFinancials2?.map((fin) => {
                return {
                  symbol: fin?.symbol,

                  eps: fin?.details?.quarterly[i]?.EarningsPerShareDiluted
                    ? fin?.details?.quarterly[i]?.EarningsPerShareDiluted
                    : fin?.details?.quarterly[i]
                        ?.EarningsPerShareBasicAndDiluted,
                };
              }),
            });
            // console.log("quarterly details", quarterlyDetails);
          }
        }
        console.log("runung 4");
        setReportedFinancialsForEPS(quarterlyDetails);
        console.log("quarterly details EPS", quarterlyDetails);
      }
      if (financialPeriod == "annual") {
        let length = reportedFinancials2[0]?.details?.annual?.length;
        let smallestIncIndex = 0;
        reportedFinancials2?.map((i, index) => {
          if (i?.details?.annual?.length < length) {
            console.log(i?.details?.annual?.length);
            length = i?.details?.annual?.length;
            smallestIncIndex = index;
          }
        });
        // console.log("length", length, smallestIncIndex);
        let annualDetails = [];
        let financials = reportedFinancials2?.details?.annual;
        for (let i = 15; i >= 0; i--) {
          if (
            reportedFinancials2[smallestIncIndex]?.details?.annual[i]?.subkey
          ) {
            console.log("running 2", reportedFinancials2);

            annualDetails?.push({
              financialPeriod: reportedFinancials2[0]?.details?.annual[i]
                ?.DocumentFiscalYearFocus
                ? reportedFinancials2[0]?.details?.annual[i]
                    ?.DocumentFiscalYearFocus
                : reportedFinancials2[0]?.details?.annual[i]?.formFiscalYear,
              earningsPerShare: reportedFinancials2?.map((fin) => {
                return {
                  symbol: fin?.symbol,
                  eps: fin?.details?.quarterly[i]?.EarningsPerShareDiluted
                    ? fin?.details?.quarterly[i]?.EarningsPerShareDiluted
                    : fin?.details?.quarterly[i]
                        ?.EarningsPerShareBasicAndDiluted,
                };
              }),
            });
          }
        }

        setReportedFinancialsForEPS(annualDetails);
        console.log("annual details eps", annualDetails);
      }
    }
    /************* market cap */
    const fetchChart = async (fetchDate, symbol) => {
      let x = await axios.get(
        `https://cloud.iexapis.com/stable/stock/${symbol}/chart/date/${fetchDate}?chartCloseOnly=true&&chartByDay=true&&token=${token}`
      );
      return x;
    };
    const getMarketSharePrice = async (periodEnd, symbol) => {
      let chartData = {};
      let periodEndDate = new Date(periodEnd);
      console.log("symbol", symbol, periodEndDate);

      let i = 0;
      while (i < 4) {
        let year = periodEndDate.getUTCFullYear();
        let month = periodEndDate.getUTCMonth() + 1;
        let day = periodEndDate.getUTCDate() - i;
        if (month < 10) {
          month = "0" + month.toString();
        }
        if (day < 10) {
          day = "0" + day.toString();
        }
        let dateForFetch = parseInt(
          year?.toString() + month?.toString() + day?.toString()
        );
        // console.log("turn", i, symbol, " fetch date", dateForFetch);
        /********* */
        chartData = await fetchChart(dateForFetch, symbol);
        if (chartData?.data?.length > 0) {
          //   console.log("chart data", chartData?.data);
          i = 4;
          return chartData?.data[0]?.date ? chartData?.data[0] : {};
        }

        /********* */
        i++;
      }
    };

    if (attribute == "Market Cap") {
      console.log("market cap inner");
      if (financialPeriod == "quarterly") {
        console.log(
          "reported quarterly",
          reportedFinancials2?.length > 0,
          reportedFinancials2
        );
        if (reportedFinancials2?.length > 0) {
          //   console.log("market cap inner 3");
          const calcAndSetMarketCap = async () => {
            let length = reportedFinancials2[0]?.details?.quarterly?.length;
            let smallestIncIndex = 0;
            reportedFinancials2?.map((i, index) => {
              if (i?.details?.quarterly?.length < length) {
                console.log(i?.details?.quarterly?.length);
                length = i?.details?.quarterly?.length;
                smallestIncIndex = index;
              }
            });
            console.log("length", length, smallestIncIndex);
            let quarterlyDetails = [];
            let financials = reportedFinancials2?.details?.quarterly;
            for (let i = 15; i >= 0; i--) {
              if (
                reportedFinancials2[smallestIncIndex]?.details?.quarterly[i]
                  ?.subkey
              ) {
                // console.log("running 2", reportedFinancials2);
                /******* */
                let mcFetched = false;

                /******* */
                let MarketCaps = [];
                reportedFinancials2?.map(async (fin, index) => {
                  let p = fin?.details?.quarterly[i]?.periodEnd;
                  // console.log("period", p);
                  let price = await getMarketSharePrice(p, fin?.symbol);
                  //console.log("price", price);
                  let outstandingShares = fin?.details?.quarterly[i]
                    ?.CommonStockSharesOutstanding
                    ? fin?.details?.quarterly[i]?.CommonStockSharesOutstanding
                    : fin?.details?.quarterly[i]
                        ?.EntityCommonStockSharesOutstanding;

                  let marketCap = price?.close * outstandingShares;
                  console.log("price", price?.close);
                  console.log("outstanding shares", outstandingShares);
                  console.log("market cap", marketCap);
                  if (marketCap > 1) {
                    console.log("hahaha", {
                      symbol: fin?.symbol,
                      marketCap: marketCap,
                    });
                  }

                  if (marketCap > 1) {
                    MarketCaps.push({
                      symbol: fin?.symbol,
                      marketCap: marketCap,
                    });
                    mcFetched = true;

                    if (MarketCaps?.length == reportedFinancials2?.length) {
                      if (mcFetched) {
                        console.log("running");
                        quarterlyDetails?.push({
                          financialPeriod: reportedFinancials2[0]?.details
                            ?.quarterly[i]?.DocumentFiscalPeriodFocus
                            ? `FY${
                                reportedFinancials2[0]?.details?.quarterly[i]
                                  ?.DocumentFiscalYearFocus - 2000
                              } ${
                                reportedFinancials2[0]?.details?.quarterly[i]
                                  ?.DocumentFiscalPeriodFocus
                              }`
                            : reportedFinancials2[0]?.details?.quarterly[i]
                                ?.formFiscalQuarter
                            ? `FY${
                                reportedFinancials2[0]?.details?.quarterly[i]
                                  ?.formFiscalYear - 2000
                              } Q${
                                reportedFinancials2[0]?.details?.quarterly[i]
                                  ?.formFiscalQuarter
                              }`
                            : `FY Q`,
                          marketCap: MarketCaps,
                          index: i,
                        });
                        // console?.log(
                        //   "quarterly details",
                        //   quarterlyDetails,
                        //   quarterlyDetails?.length,
                        //   length
                        // );
                        if (quarterlyDetails?.length == length) {
                          //   console.log("runung 4");
                          let sortedData = quarterlyDetails.sort((a, b) => {
                            return b.index - a.index;
                          });
                          setReportedFinancialsForMC(sortedData);
                          console.log("quarterly details", sortedData);
                        }
                      }
                    }
                  }

                  // }
                });

                // console.log("quarterly details", quarterlyDetails);
              }
            }
          };
          calcAndSetMarketCap();
        }
        /******************** */
      }
      if (financialPeriod == "annual") {
        if (reportedFinancials2?.length > 0) {
          //   console.log("market cap inner 3");
          const calcAndSetMarketCap = async () => {
            let length = reportedFinancials2[0]?.details?.annual?.length;
            let smallestIncIndex = 0;
            reportedFinancials2?.map((i, index) => {
              if (i?.details?.quarterly?.length < length) {
                console.log(i?.details?.annual?.length);
                length = i?.details?.annual?.length;
                smallestIncIndex = index;
              }
            });
            // console.log("length", length, smallestIncIndex);
            let annualDetails = [];
            let financials = reportedFinancials2?.details?.annual;
            for (let i = 15; i >= 0; i--) {
              if (
                reportedFinancials2[smallestIncIndex]?.details?.annual[i]
                  ?.subkey
              ) {
                // console.log("running 2", reportedFinancials2);
                /******* */
                let mcFetched = false;

                /******* */
                let MarketCaps = [];
                reportedFinancials2?.map(async (fin) => {
                  let p = fin?.details?.annual[i]?.periodEnd;
                  console.log("fin", fin?.symbol);
                  let price = await getMarketSharePrice(p, fin?.symbol);
                  // console.log("price", price);
                  let outstandingShares = fin?.details?.annual[i]
                    ?.CommonStockSharesOutstanding
                    ? fin?.details?.annual[i]?.CommonStockSharesOutstanding
                    : fin?.details?.annual[i]
                        ?.EntityCommonStockSharesOutstanding;

                  let marketCap = price?.close * outstandingShares;
                  // console.log("market cap", marketCap);
                  // if (marketCap > 1) {
                  //   console.log("hahaha", {
                  //     symbol: fin?.symbol,
                  //     marketCap: marketCap,
                  //   });

                  if (marketCap > 1) {
                    MarketCaps.push({
                      symbol: fin?.symbol,
                      marketCap: marketCap,
                    });
                    mcFetched = true;

                    if (MarketCaps?.length == reportedFinancials2?.length) {
                      if (mcFetched) {
                        // console.log("running");
                        annualDetails?.push({
                          financialPeriod: reportedFinancials2[0]?.details
                            ?.annual[i]?.DocumentFiscalYearFocus
                            ? `${reportedFinancials2[0]?.details?.annual[i]?.DocumentFiscalYearFocus} `
                            : reportedFinancials2[0]?.details?.annual[i]
                                ?.fiscalYear
                            ? `${reportedFinancials2[0]?.details?.annual[i]?.fiscalYear}`
                            : `${reportedFinancials2[0]?.details?.annual[i]?.formFiscalYear}`,
                          marketCap: MarketCaps,
                        });
                        // console?.log(
                        //   "annual details",
                        //   annualDetails,
                        //   annualDetails?.length,
                        //   length
                        // );
                        if (annualDetails?.length == length) {
                          //   console.log("runung 4");
                          let sortedData = annualDetails.sort((a, b) => {
                            return a.financialPeriod - b.financialPeriod;
                          });
                          setReportedFinancialsForMC(sortedData);
                          //   console.log("annual details", sortedData);
                        }
                      }
                    }
                  }

                  // }
                });

                // console.log("quarterly details", quarterlyDetails);
              }
            }
          };
          calcAndSetMarketCap();
        }
      }
    }
  }, [reportedFinancials, financialPeriod]);
  const handleFPChange = (event) => {
    setFinancialPeriod(event.target.value);
  };
  const controlProps = (item) => ({
    checked: financialPeriod === item,
    onChange: handleFPChange,
    value: item,
    name: "color-radio-button-demo",
    inputProps: { "aria-label": item },
  });

  return (
    <Box className="price__details__container" bgcolor={"bgPrimary.main"}>
      <Box
        sx={{
          display: "flex",
          gap: "30px",
          marginTop: "40px",
          width: "100%",
          justifyContent: "space-around",
        }}
      >
        <Box>
          {stocks?.length > 10 && (
            <SelectStocksToCompare
              stocks={stocks}
              setStocksToCompare={setStocksToCompare}
            />
          )}
          {error && (
            <Box
              sx={{
                fontSize: "0.8rem",
                fontFamily: "public sans",
                marginTop: "10px",
                color: "#db1010",
              }}
            >
              {error}
            </Box>
          )}
        </Box>
        <Box>
          <AttributeSelect setAttribute={setAttribute} />
        </Box>
      </Box>
      <Box sx={{ display: "flex", gap: "30px" }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {" "}
          <Radio
            {...controlProps("quarterly")}
            sx={{
              color: "fontSecondaryColor.main",
              "&.Mui-checked": {
                color: "rRedColor.main",
              },
            }}
          />
          <Box
            color="fontPrimaryColor.main"
            sx={{
              fontFamily: "public sans",
              fontSize: "0.8rem",
              fontWeight: "400",
            }}
          >
            Quarterly
          </Box>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {" "}
          <Radio
            {...controlProps("annual")}
            sx={{
              color: "fontSecodaryColor.main",
              "&.Mui-checked": {
                color: "rRedColor.main",
              },
            }}
          />
          <Box
            color="fontPrimaryColor.main"
            sx={{
              fontFamily: "public sans",
              fontSize: "0.8rem",
              fontWeight: "400",
            }}
          >
            Annual
          </Box>
        </Box>
      </Box>
      {finalIncomeDetails && attribute == "Net Income" ? (
        <Box sx={{ width: "100%" }}>
          <NetIncomeChart
            incomeDetails={finalIncomeDetails}
            financialPeriod={financialPeriod}
            isComparing={true}
            mode={mode}
          />
        </Box>
      ) : attribute == "Operating Expenses" ? (
        <Box sx={{ width: "100%" }}>
          <OPEXCharts
            incomeDetails={finalIncomeDetailsForOPEX}
            financialPeriod={financialPeriod}
            mode={mode}
            isComparing={true}
          />
        </Box>
      ) : attribute == "Outstanding Shares" ? (
        <Box sx={{ width: "100%" }}>
          <OutstandingSharesChart
            // incomeDetails={incomeDetails}
            financialPeriod={financialPeriod}
            reportedFinancials={reportedFinancialsForOS}
            mode={mode}
            isComparing={true}
          />
        </Box>
      ) : attribute == "EPS" ? (
        <Box sx={{ width: "100%" }}>
          <EarningsPerShareChart
            // incomeDetails={incomeDetails}
            financialPeriod={financialPeriod}
            reportedFinancials={reportedFinancialsForEPS}
            mode={mode}
            isComparing={true}
          />
        </Box>
      ) : attribute == "Market Cap" ? (
        <Box sx={{ width: "100%" }}>
          <MarketCapChart
            // incomeDetails={incomeDetails}
            financialPeriod={financialPeriod}
            reportedFinancials={reportedFinancialsForMC}
            mode={mode}
            isComparing={true}
          />
        </Box>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default StockComparison;
///**********attributes fiels */
function AttributeSelect({ setAttribute }) {
  return (
    <Box sx={{ minWidth: 120, marginTop: "0px" }}>
      <FormControl fullWidth>
        <InputLabel
          variant="standard"
          htmlFor="uncontrolled-native"
          sx={{
            color: "fontPrimaryColor.main",
            fontFamily: "public sans",
            fontSize: "16px !important",
            padding: " 5px 5px 4px 0px",
            lineHeight: " 1.5",
          }}
        >
          Attribute
        </InputLabel>
        <NativeSelect
          defaultValue={"EPS"}
          inputProps={{
            name: "Attribute",
            id: "uncontrolled-native",
          }}
          sx={{ fontSize: "14px", padding: " 0", lineHeight: " 1.5" }}
          onChange={(e) => setAttribute(e.target.value)}
        >
          <option value={"Market Cap"}>EPS</option>
          <option value={"Market Cap"}>Market Cap</option>
          <option value={"Outstanding Shares"}>Outstanding Shares</option>
          <option value={"Operating Expenses"}>Operating Expenses</option>
          <option value={"Net Income"}>Net Income</option>
        </NativeSelect>
      </FormControl>
    </Box>
  );
}

/***** companies field */
const Root = styled("div")(
  ({ theme }) => `
    color: ${
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,0.65)"
        : "rgba(0,0,0,.85)"
    };
    font-size: 14px;
  `
);

const Label = styled("label")(
  ({ theme }) => `
padding: 0 0 4px;
 line-height: 1.5;
display: block;
color: ${theme.palette.mode === "dark" ? "#f6f6f6" : "#262626"};
font-size:13px;
font-family:'public sans';

`
);

const InputWrapper = styled("div")(
  ({ theme }) => `
    width: 400px;
    border: 1px solid ${theme.palette.mode === "dark" ? "#434343" : "#d9d9d9"};
    background-color: ${theme.palette.mode === "dark" ? "#0a1929" : "#fff"};
    border-radius: 4px;
    padding: 1px;
    display: flex;
    flex-wrap: wrap;
    font-family:'public sans';

    &:hover {
      border-color: ${theme.palette.mode === "dark" ? "#434343" : "#d9d9d9"};
    }

    &.focused {
      border-color: ${theme.palette.mode === "dark" ? "#000" : "#fff"};
      box-shadow: 0 0 0 2px rgba(24, 24, 44, 0.2);
    }

    & input {
      background-color: ${theme.palette.mode === "dark" ? "#0a1929" : "#fff"};
      color: ${
        theme.palette.mode === "dark"
          ? "rgba(255,255,255,0.65)"
          : "rgba(0,0,0,.85)"
      };
      height: 30px;
      box-sizing: border-box;
      padding: 4px 6px;
      width: 0;
      min-width: 30px;
      flex-grow: 1;
      border: 0;
      margin: 0;
      outline: 0;
    }
  `
);

function Tag(props) {
  const { label, onDelete, ...other } = props;
  return (
    <div {...other}>
      <span>{label}</span>
      <CloseIcon onClick={onDelete} />
    </div>
  );
}

Tag.propTypes = {
  label: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const StyledTag = styled(Tag)(
  ({ theme }) => `
    display: flex;
    align-items: center;
    height: 24px;
    margin: 2px;
    line-height: 22px;
    font-family:'public sans';
    background-color: ${
      theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "#fafafa"
    };
    border: 1px solid ${theme.palette.mode === "dark" ? "#303030" : "#e8e8e8"};
    border-radius: 2px;
    box-sizing: content-box;
    padding: 0 4px 0 10px;
    outline: 0;
    overflow: hidden;

    &:focus {
      border-color: ${theme.palette.mode === "dark" ? "#177ddc" : "#40a9ff"};
      background-color: ${
        theme.palette.mode === "dark" ? "#003b57" : "#e6f7ff"
      };
    }

    & span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    & svg {
      font-size: 17px;
      cursor: pointer;
      padding: 4px;
    }
  `
);

const Listbox = styled("ul")(
  ({ theme }) => `
    width: 400px;
    margin: 2px 0 0;
    padding: 0;
    position: relative;
    list-style: none;
    background-color: ${theme.palette.mode === "dark" ? "#141414" : "#fff"};
    overflow: auto;
    max-height: 250px;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1;

    & li {
      padding: 5px 12px;
      display: flex;

      & span {
        flex-grow: 1;
      }

      & svg {
        color: transparent;
      }
    }

    & li[aria-selected='true'] {
      background-color: ${
        theme.palette.mode === "dark" ? "#2b2b2b" : "#fafafa"
      };
      font-weight: 600;

      & svg {
        color: #1890ff;
      }
    }

    & li.${autocompleteClasses.focused} {
      background-color: ${
        theme.palette.mode === "dark" ? "#003b57" : "#e6f7ff"
      };
      cursor: pointer;

      & svg {
        color: currentColor;
      }
    }
  `
);

function SelectStocksToCompare({ stocks, setStocksToCompare }) {
  const params = useParams();
  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    focused,
    setAnchorEl,
  } = useAutocomplete({
    id: "customized-hook-demo",
    defaultValue: [{ symbol: params?.symbol?.toLocaleUpperCase() }],
    multiple: true,
    options: stocks,
    getOptionLabel: (option) => option.symbol,
  });

  useEffect(() => {
    console.log("value", value);
    setStocksToCompare(value);
  }, [value]);
  return (
    <Root>
      <div {...getRootProps()}>
        <Label {...getInputLabelProps()}>Companies</Label>
        <InputWrapper ref={setAnchorEl} className={focused ? "focused" : ""}>
          {value.map((option, index) => (
            <StyledTag label={option.symbol} {...getTagProps({ index })} />
          ))}

          <input
            {...getInputProps()}
            disabled={value?.length > 4 ? true : false}
          />
        </InputWrapper>
      </div>
      {groupedOptions.length > 0 ? (
        <Listbox {...getListboxProps()}>
          {groupedOptions.map((option, index) => (
            <li {...getOptionProps({ option, index })}>
              <span>{option.symbol}</span>
              <CheckIcon fontSize="small" />
            </li>
          ))}
        </Listbox>
      ) : null}
    </Root>
  );
}
